export default __webpack_public_path__ + "static/media/bcf.969b7918.svg";